import { render, staticRenderFns } from "./CarroCreate.vue?vue&type=template&id=54d473ca&"
import script from "./CarroCreate.vue?vue&type=script&lang=js&"
export * from "./CarroCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports